/*!
 * Jersey Pickles — Chat Widget
 * Vanilla JS embeddable chat widget served as a theme asset.
 * Loaded from layout/theme.liquid via:
 *   <script src="{{ 'chat-widget.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  if (window.__jpChatWidgetLoaded) return;
  window.__jpChatWidgetLoaded = true;

  // ---------- Config ----------
  var API_BASE    = 'https://picker-backend-ffa2d0c892f5.herokuapp.com';
  var API_PREFIX  = API_BASE + '/api/chat';
  var SOCKET_URL  = API_BASE + '/client';
  var SOCKET_PATH = '/chat-socket.io/';
  var SOCKET_CDN  = 'https://cdn.socket.io/4.8.1/socket.io.min.js';
  var STORAGE_KEY = 'jpChatSessionId';
  var ASSIGNED_AGENT_KEY = 'jpChatAssignedAgent';
  var CALLOUT_DISMISS_KEY = 'jpChatCalloutDismissed';

  var PRIMARY = '#0088cc';
  var ACCENT  = '#00aa66';
  var PICKLE_DARK = '#2d5c1a';
  var PICKLE_MID  = '#5fa83a';

  // ---------- Business hours ----------
  // Outside these hours the widget swaps to a "leave a message" form instead
  // of allowing live chat. Edit these constants to change hours/days/tz.
  var BUSINESS_TZ          = 'America/New_York';      // NJ time
  var BUSINESS_OPEN_HOUR   = 9;                       // 9 AM (inclusive)
  var BUSINESS_CLOSE_HOUR  = 19;                      // 7 PM (exclusive)
  var BUSINESS_DAYS        = [0,1,2,3,4,5,6];         // 0=Sun … 6=Sat. All days by default.
  var BUSINESS_HOURS_LABEL = '9 AM – 7 PM ET';        // Shown to the customer.

  // ---------- SVG art ----------
  // Cute pickle character — waving hand, friendly face. Designed at 64x64.
  var PICKLE_SVG =
    '<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<defs>' +
        '<linearGradient id="jpPbody" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#cdee9c"/>' +
          '<stop offset="55%" stop-color="#86c958"/>' +
          '<stop offset="100%" stop-color="#5fa83a"/>' +
        '</linearGradient>' +
        '<radialGradient id="jpPhi" cx="0.3" cy="0.25" r="0.4">' +
          '<stop offset="0%" stop-color="#fff" stop-opacity="0.7"/>' +
          '<stop offset="100%" stop-color="#fff" stop-opacity="0"/>' +
        '</radialGradient>' +
      '</defs>' +
      // stem
      '<path d="M30 11 Q32 5 38 6 Q36 11 34 13" stroke="#2d5c1a" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      // body
      '<ellipse cx="32" cy="38" rx="13" ry="20" fill="url(#jpPbody)" stroke="#2d5c1a" stroke-width="1.5"/>' +
      // highlight
      '<ellipse cx="26" cy="32" rx="5" ry="11" fill="url(#jpPhi)"/>' +
      // bumps
      '<circle cx="25" cy="44" r="1.3" fill="#2d5c1a" opacity="0.75"/>' +
      '<circle cx="40" cy="34" r="1.3" fill="#2d5c1a" opacity="0.75"/>' +
      '<circle cx="34" cy="52" r="1.3" fill="#2d5c1a" opacity="0.75"/>' +
      '<circle cx="38" cy="46" r="1.0" fill="#2d5c1a" opacity="0.75"/>' +
      '<circle cx="24" cy="28" r="1.0" fill="#2d5c1a" opacity="0.75"/>' +
      // cheeks
      '<ellipse cx="24" cy="40" rx="2.2" ry="1.4" fill="#ff9aa2" opacity="0.65"/>' +
      '<ellipse cx="40" cy="40" rx="2.2" ry="1.4" fill="#ff9aa2" opacity="0.65"/>' +
      // eyes (whites)
      '<ellipse cx="27" cy="34" rx="3" ry="3.6" fill="#fff"/>' +
      '<ellipse cx="37" cy="34" rx="3" ry="3.6" fill="#fff"/>' +
      // pupils
      '<circle cx="28" cy="35" r="1.5" fill="#1a1a1a"/>' +
      '<circle cx="38" cy="35" r="1.5" fill="#1a1a1a"/>' +
      // eye shine
      '<circle cx="28.5" cy="34" r="0.55" fill="#fff"/>' +
      '<circle cx="38.5" cy="34" r="0.55" fill="#fff"/>' +
      // mouth (small open smile)
      '<path d="M28 43 Q32 46.5 36 43" stroke="#1a1a1a" stroke-width="1.7" fill="none" stroke-linecap="round"/>' +
      '<path d="M30 44 Q32 45.5 34 44" fill="#ff7a8a" opacity="0.7"/>' +
      // waving hand (top right)
      '<g class="jp-wave-hand" transform-origin="46px 30px">' +
        '<path d="M44 30 Q48 24 51 18 Q52 14 55 15 Q57 17 55 20 Q53 26 50 31 Q48 34 45 33 Z" fill="url(#jpPbody)" stroke="#2d5c1a" stroke-width="1.3" stroke-linejoin="round"/>' +
        '<circle cx="53" cy="16" r="1.2" fill="#fff" opacity="0.6"/>' +
      '</g>' +
    '</svg>';

  // Small pickle for header avatar — same character, simplified.
  var PICKLE_MINI_SVG =
    '<svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<defs>' +
        '<linearGradient id="jpMini" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#cdee9c"/>' +
          '<stop offset="100%" stop-color="#5fa83a"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<path d="M18 5 Q20 1 24 3" stroke="#2d5c1a" stroke-width="1.6" fill="none" stroke-linecap="round"/>' +
      '<ellipse cx="20" cy="22" rx="9" ry="14" fill="url(#jpMini)" stroke="#2d5c1a" stroke-width="1.1"/>' +
      '<ellipse cx="16" cy="18" rx="2" ry="5" fill="#fff" opacity="0.45"/>' +
      '<circle cx="14" cy="22" r="0.8" fill="#2d5c1a" opacity="0.7"/>' +
      '<circle cx="26" cy="26" r="0.8" fill="#2d5c1a" opacity="0.7"/>' +
      '<circle cx="22" cy="32" r="0.7" fill="#2d5c1a" opacity="0.7"/>' +
      '<ellipse cx="16.5" cy="20" rx="2" ry="2.3" fill="#fff"/>' +
      '<ellipse cx="23.5" cy="20" rx="2" ry="2.3" fill="#fff"/>' +
      '<circle cx="17" cy="20.5" r="1" fill="#1a1a1a"/>' +
      '<circle cx="24" cy="20.5" r="1" fill="#1a1a1a"/>' +
      '<path d="M17 26 Q20 28 23 26" stroke="#1a1a1a" stroke-width="1.2" fill="none" stroke-linecap="round"/>' +
    '</svg>';

  var SEND_SVG =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M22 2L11 13"></path><path d="M22 2L15 22 11 13 2 9 22 2z"></path>' +
    '</svg>';

  var CLOSE_SVG =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true">' +
      '<path d="M6 6 L18 18 M18 6 L6 18"/>' +
    '</svg>';

  var ATTACH_SVG =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.49"/>' +
    '</svg>';

  // ---------- File upload config ----------
  var MAX_FILE_BYTES = 10 * 1024 * 1024; // 10 MB (matches backend)
  var ALLOWED_MIMES = [
    'image/jpeg', 'image/png', 'image/gif', 'image/webp',
    'image/heic', 'image/heif', 'application/pdf'
  ];

  // ---------- Lifecycle timing ----------
  // If a previously-closed conversation is older than this on page load, we
  // silently nuke the local session so the next visit starts fresh.
  var CLOSED_AUTO_RESET_MS = 60 * 60 * 1000;        // 1 hour
  // After this much inactivity with the panel open, inject a gentle
  // "still there?" system message (the backend is what actually closes the
  // conversation — this is only a customer-side nudge).
  var IDLE_REMINDER_MS     = 15 * 60 * 1000;        // 15 minutes
  // While the panel is closed, poll /history occasionally so we still notice
  // a server-side close if the socket died silently.
  var BG_POLL_MS           = 5 * 60 * 1000;         // 5 minutes

  // ---------- State ----------
  var state = {
    sessionId: null,
    conversationId: null,
    status: 'bot',
    assignedAgent: '',
    initialized: false,
    messages: [],
    messageIds: Object.create(null),
    socket: null,
    socketLoading: false,
    open: false,
    unread: 0,
    screen: 'identify',
    typingTimeoutId: null,
    typingShown: false,
    typingCaption: null,
    typingAutoHideTimer: null,
    sending: false,
    calloutShown: false,
    feedbackSubmitted: false,
    pendingAttachments: [],
    idleTimerId: null,
    idleReminderShown: false,
    bgPollIntervalId: null
  };

  var el = {};

  // ---------- Helpers ----------
  function $(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (k === 'style' && typeof attrs[k] === 'object') {
          for (var s in attrs[k]) n.style[s] = attrs[k][s];
        } else if (k === 'class') {
          n.className = attrs[k];
        } else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') {
          n.addEventListener(k.slice(2), attrs[k]);
        } else if (k === 'html') {
          n.innerHTML = attrs[k];
        } else {
          n.setAttribute(k, attrs[k]);
        }
      }
    }
    if (children) {
      if (!Array.isArray(children)) children = [children];
      children.forEach(function (c) {
        if (c == null) return;
        n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return n;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatTime(ts) {
    try {
      var d = new Date(ts);
      var h = d.getHours(), m = d.getMinutes();
      var ampm = h >= 12 ? 'PM' : 'AM';
      h = h % 12 || 12;
      return h + ':' + (m < 10 ? '0' + m : m) + ' ' + ampm;
    } catch (e) { return ''; }
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = resolve;
      s.onerror = function () { reject(new Error('Failed to load ' + src)); };
      document.head.appendChild(s);
    });
  }

  function apiPost(path, body) {
    return fetch(API_PREFIX + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(handleJson);
  }
  function apiGet(path) { return fetch(API_PREFIX + path).then(handleJson); }
  function handleJson(r) {
    return r.json().then(function (j) {
      if (!r.ok || j.success === false) {
        var err = new Error((j && j.message) || ('HTTP ' + r.status));
        err.payload = j; throw err;
      }
      return j;
    });
  }

  function safeStorageGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function safeStorageSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function safeStorageRemove(k) { try { localStorage.removeItem(k); } catch (e) {} }

  function isBusinessHours() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: BUSINESS_TZ,
        hour: 'numeric', hour12: false, weekday: 'short'
      }).formatToParts(new Date());
      var hour = parseInt(parts.find(function (p) { return p.type === 'hour'; }).value, 10);
      var dayStr = parts.find(function (p) { return p.type === 'weekday'; }).value;
      var dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var day = dayMap[dayStr];
      return BUSINESS_DAYS.indexOf(day) !== -1
          && hour >= BUSINESS_OPEN_HOUR
          && hour <  BUSINESS_CLOSE_HOUR;
    } catch (e) {
      // Fail open: if Intl is unavailable (very old browser), allow chat.
      return true;
    }
  }

  // ---------- Styles ----------
  function injectStyles() {
    if (document.getElementById('jp-chat-styles')) return;
    var css = [
      '#jp-chat-root,#jp-chat-root *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;}',
      // ----- bubble -----
      '#jp-chat-bubble{position:fixed;right:22px;bottom:22px;width:68px;height:68px;border-radius:50%;',
        'background:radial-gradient(circle at 30% 25%,#ffffff 0%,#f0fbe9 55%,#dff5cc 100%);',
        'box-shadow:0 12px 32px rgba(0,136,204,0.28),0 4px 12px rgba(0,170,102,0.22),0 0 0 3px rgba(255,255,255,0.9) inset;',
        'cursor:pointer;z-index:2147483600;display:flex;align-items:center;justify-content:center;',
        'border:none;padding:0;transition:transform .18s cubic-bezier(.34,1.56,.64,1),box-shadow .18s;}',
      '#jp-chat-bubble:hover{transform:scale(1.08) rotate(-3deg);box-shadow:0 16px 40px rgba(0,136,204,0.35),0 6px 16px rgba(0,170,102,0.28),0 0 0 3px rgba(255,255,255,0.9) inset;}',
      '#jp-chat-bubble:active{transform:scale(0.97);}',
      '#jp-chat-bubble svg{width:52px;height:52px;display:block;pointer-events:none;}',
      '#jp-chat-bubble .jp-close-x{display:none;color:#fff;}',
      '#jp-chat-bubble.jp-is-open{background:linear-gradient(135deg,' + PRIMARY + ' 0%,' + ACCENT + ' 100%);}',
      '#jp-chat-bubble.jp-is-open .jp-pickle{display:none;}',
      '#jp-chat-bubble.jp-is-open .jp-close-x{display:flex;align-items:center;justify-content:center;width:52px;height:52px;}',
      '#jp-chat-bubble.jp-is-open svg{width:22px;height:22px;}',
      // pulse ring
      '#jp-chat-bubble::before,#jp-chat-bubble::after{content:"";position:absolute;inset:0;border-radius:50%;border:2px solid rgba(0,170,102,0.55);pointer-events:none;}',
      '#jp-chat-bubble::before{animation:jp-pulse 2.4s ease-out infinite;}',
      '#jp-chat-bubble::after{animation:jp-pulse 2.4s ease-out 1.2s infinite;}',
      '#jp-chat-bubble.jp-is-open::before,#jp-chat-bubble.jp-is-open::after{display:none;}',
      '@keyframes jp-pulse{0%{transform:scale(1);opacity:0.7;}80%{transform:scale(1.45);opacity:0;}100%{transform:scale(1.45);opacity:0;}}',
      // waving hand animation
      '.jp-wave-hand{transform-origin:46px 30px;animation:jp-wave 2.5s ease-in-out infinite;}',
      '@keyframes jp-wave{0%,60%,100%{transform:rotate(0deg);}10%,30%,50%{transform:rotate(18deg);}20%,40%{transform:rotate(-12deg);}}',
      // gentle bob
      '#jp-chat-bubble .jp-pickle{animation:jp-bob 3.6s ease-in-out infinite;display:flex;align-items:center;justify-content:center;}',
      '@keyframes jp-bob{0%,100%{transform:translateY(0);}50%{transform:translateY(-2px);}}',
      // unread badge
      '#jp-chat-bubble .jp-badge{position:absolute;top:-4px;right:-4px;min-width:22px;height:22px;border-radius:11px;',
        'background:#ff3b30;color:#fff;font-size:12px;font-weight:700;display:none;align-items:center;justify-content:center;padding:0 6px;',
        'box-shadow:0 2px 6px rgba(255,59,48,0.4);}',
      '#jp-chat-bubble.jp-has-unread .jp-badge{display:flex;animation:jp-pop .35s cubic-bezier(.34,1.56,.64,1);}',
      '@keyframes jp-pop{0%{transform:scale(0);}100%{transform:scale(1);}}',
      // ----- callout (Need help?) -----
      '#jp-chat-callout{position:fixed;right:100px;bottom:32px;background:#fff;padding:12px 16px 12px 14px;',
        'border-radius:18px;box-shadow:0 12px 32px rgba(0,0,0,0.18),0 0 0 1px rgba(0,0,0,0.04);',
        'font-size:14px;color:#1a3140;font-weight:500;line-height:1.35;z-index:2147483599;',
        'display:none;align-items:center;gap:8px;max-width:240px;cursor:pointer;',
        'animation:jp-callout-in .5s cubic-bezier(.34,1.56,.64,1) both;}',
      '#jp-chat-callout.jp-show{display:flex;}',
      '#jp-chat-callout::after{content:"";position:absolute;right:-8px;top:50%;transform:translateY(-50%);',
        'width:0;height:0;border-top:8px solid transparent;border-bottom:8px solid transparent;border-left:10px solid #fff;}',
      '#jp-chat-callout .jp-callout-emoji{font-size:18px;line-height:1;}',
      '#jp-chat-callout .jp-callout-text{flex:1;}',
      '#jp-chat-callout .jp-callout-strong{display:block;font-weight:700;color:#0a3147;}',
      '#jp-chat-callout .jp-callout-sub{display:block;font-size:12px;color:#5e7585;font-weight:500;margin-top:1px;}',
      '#jp-chat-callout .jp-callout-x{position:absolute;top:-6px;right:-6px;width:22px;height:22px;border-radius:50%;',
        'background:#fff;border:1px solid #e3e6ea;color:#666;font-size:13px;cursor:pointer;display:flex;align-items:center;justify-content:center;',
        'line-height:1;padding:0;box-shadow:0 2px 4px rgba(0,0,0,0.08);}',
      '#jp-chat-callout .jp-callout-x:hover{background:#f5f5f5;color:#111;}',
      '@keyframes jp-callout-in{0%{opacity:0;transform:translateX(20px) scale(0.9);}100%{opacity:1;transform:none;}}',
      '@keyframes jp-callout-out{0%{opacity:1;transform:none;}100%{opacity:0;transform:translateX(20px) scale(0.9);}}',
      '#jp-chat-callout.jp-hiding{animation:jp-callout-out .25s ease-in both;}',
      // ----- panel -----
      '#jp-chat-panel{position:fixed;right:22px;bottom:100px;width:380px;height:580px;max-height:calc(100vh - 120px);',
        'background:#fff;border-radius:20px;box-shadow:0 24px 60px rgba(0,40,80,0.25),0 8px 24px rgba(0,40,80,0.12);',
        'display:none;flex-direction:column;overflow:hidden;z-index:2147483601;',
        'transform-origin:bottom right;}',
      '#jp-chat-panel.jp-open{display:flex;animation:jp-panel-in .28s cubic-bezier(.34,1.56,.64,1) both;}',
      '@keyframes jp-panel-in{0%{opacity:0;transform:translateY(16px) scale(0.94);}100%{opacity:1;transform:none;}}',
      // header
      '.jp-header{background:linear-gradient(135deg,' + PRIMARY + ' 0%,#0a78b3 45%,' + ACCENT + ' 100%);color:#fff;padding:16px 18px;',
        'display:flex;align-items:center;gap:12px;position:relative;overflow:hidden;}',
      '.jp-header::before{content:"";position:absolute;top:-40%;right:-20%;width:180px;height:180px;border-radius:50%;',
        'background:radial-gradient(circle,rgba(255,255,255,0.18) 0%,transparent 70%);pointer-events:none;}',
      '.jp-header .jp-avatar{width:44px;height:44px;border-radius:50%;background:#fff;',
        'display:flex;align-items:center;justify-content:center;flex-shrink:0;',
        'box-shadow:0 2px 8px rgba(0,0,0,0.15);position:relative;z-index:1;}',
      '.jp-header .jp-avatar svg{width:38px;height:38px;}',
      '.jp-header .jp-avatar::after{content:"";position:absolute;bottom:1px;right:1px;width:11px;height:11px;border-radius:50%;',
        'background:#3ddc84;border:2px solid #fff;box-shadow:0 0 0 0 rgba(61,220,132,0.7);animation:jp-online 2s infinite;}',
      '@keyframes jp-online{0%{box-shadow:0 0 0 0 rgba(61,220,132,0.7);}70%{box-shadow:0 0 0 6px rgba(61,220,132,0);}100%{box-shadow:0 0 0 0 rgba(61,220,132,0);}}',
      '.jp-header .jp-titles{flex:1;min-width:0;position:relative;z-index:1;}',
      '.jp-header .jp-title{font-weight:700;font-size:16px;line-height:1.2;letter-spacing:-0.2px;}',
      '.jp-header .jp-subtitle{font-size:12px;opacity:0.92;line-height:1.3;margin-top:2px;}',
      // banner
      '.jp-banner{padding:9px 16px;font-size:12px;font-weight:500;background:#fff8e1;color:#7a5a00;border-bottom:1px solid #ffe082;}',
      '.jp-banner.jp-banner-success{background:linear-gradient(90deg,#e8f6ee,#dff5e5);color:#0a6b3b;border-bottom-color:#bfe3cc;}',
      '.jp-banner.jp-banner-info{background:linear-gradient(90deg,#e3f2fd,#d8eefa);color:#0a4b78;border-bottom-color:#b9dcf8;}',
      // body
      '.jp-body{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px;',
        'background:linear-gradient(180deg,#f7fafd 0%,#eef4f9 100%);',
        'background-image:radial-gradient(circle at 1px 1px,rgba(0,40,80,0.04) 1px,transparent 0);background-size:18px 18px;',
        'scroll-behavior:smooth;}',
      '.jp-body::-webkit-scrollbar{width:6px;}',
      '.jp-body::-webkit-scrollbar-thumb{background:rgba(0,40,80,0.18);border-radius:3px;}',
      '.jp-body::-webkit-scrollbar-track{background:transparent;}',
      // messages
      '.jp-msg-row{display:flex;animation:jp-msg-in .28s cubic-bezier(.16,1,.3,1) both;max-width:100%;}',
      '@keyframes jp-msg-in{0%{opacity:0;transform:translateY(8px);}100%{opacity:1;transform:none;}}',
      '.jp-msg-row.jp-from-customer{justify-content:flex-end;}',
      '.jp-msg-row.jp-from-bot,.jp-msg-row.jp-from-agent{justify-content:flex-start;}',
      '.jp-msg-row.jp-from-system{justify-content:center;}',
      '.jp-msg{max-width:82%;display:flex;flex-direction:column;gap:3px;min-width:0;}',
      '.jp-caption{font-size:11px;color:#5e7585;font-weight:600;margin-bottom:1px;letter-spacing:0.2px;}',
      '.jp-from-customer .jp-caption{text-align:right;color:#7d8a96;}',
      '.jp-bubble{padding:10px 13px;border-radius:16px;font-size:14px;line-height:1.45;word-wrap:break-word;white-space:pre-wrap;',
        'box-shadow:0 1px 3px rgba(0,40,80,0.06);}',
      '.jp-from-customer .jp-bubble{background:linear-gradient(135deg,' + PRIMARY + ' 0%,#0a78b3 100%);color:#fff;border-bottom-right-radius:6px;',
        'box-shadow:0 2px 8px rgba(0,136,204,0.22);}',
      '.jp-from-bot .jp-bubble,.jp-from-agent .jp-bubble{background:#fff;color:#1a3140;border:1px solid #e3eaf0;border-bottom-left-radius:6px;}',
      '.jp-from-system .jp-bubble{background:rgba(255,255,255,0.65);color:#5e7585;font-size:12px;font-style:italic;padding:5px 12px;border-radius:14px;backdrop-filter:blur(4px);}',
      '.jp-time{font-size:10px;color:#9aabb8;margin-top:3px;font-weight:500;}',
      '.jp-from-customer .jp-time{text-align:right;}',
      // typing
      '.jp-typing{display:flex;align-items:center;gap:4px;padding:11px 14px;background:#fff;border:1px solid #e3eaf0;',
        'border-radius:16px;border-bottom-left-radius:6px;width:fit-content;box-shadow:0 1px 3px rgba(0,40,80,0.06);}',
      '.jp-typing span{width:7px;height:7px;background:#5fa83a;border-radius:50%;animation:jp-blink 1.2s infinite ease-in-out;}',
      '.jp-typing span:nth-child(2){animation-delay:.2s;}',
      '.jp-typing span:nth-child(3){animation-delay:.4s;}',
      '@keyframes jp-blink{0%,80%,100%{opacity:.3;transform:scale(0.85);}40%{opacity:1;transform:scale(1);}}',
      // footer
      '.jp-footer{border-top:1px solid #e3eaf0;background:#fff;padding:12px 14px;display:flex;flex-direction:column;gap:10px;}',
      '.jp-input-row{display:flex;gap:8px;align-items:flex-end;}',
      '.jp-input{flex:1;border:1.5px solid #dde6ed;border-radius:20px;padding:10px 16px;font-size:14px;',
        'resize:none;font-family:inherit;outline:none;max-height:120px;line-height:1.4;',
        'transition:border-color .15s,box-shadow .15s;background:#f7fafd;}',
      '.jp-input:focus{border-color:' + PRIMARY + ';background:#fff;box-shadow:0 0 0 3px rgba(0,136,204,0.12);}',
      '.jp-input:disabled{background:#f3f4f6;cursor:not-allowed;}',
      '.jp-send{background:linear-gradient(135deg,' + PRIMARY + ' 0%,' + ACCENT + ' 100%);color:#fff;border:none;border-radius:50%;',
        'width:40px;height:40px;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center;',
        'transition:transform .15s,box-shadow .15s;box-shadow:0 4px 10px rgba(0,136,204,0.25);}',
      '.jp-send:hover:not(:disabled){transform:translateY(-1px) scale(1.04);box-shadow:0 6px 14px rgba(0,136,204,0.35);}',
      '.jp-send:active:not(:disabled){transform:scale(0.96);}',
      '.jp-send:disabled{opacity:.5;cursor:not-allowed;box-shadow:none;}',
      // attach button + hidden file input
      '.jp-attach{background:#f3f6f9;color:#5e7585;border:1.5px solid #dde6ed;border-radius:50%;width:40px;height:40px;',
        'cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center;',
        'transition:all .15s;padding:0;}',
      '.jp-attach:hover:not(:disabled){background:#fff;border-color:' + PRIMARY + ';color:' + PRIMARY + ';transform:translateY(-1px);}',
      '.jp-attach:active:not(:disabled){transform:scale(0.96);}',
      '.jp-attach:disabled{opacity:.5;cursor:not-allowed;}',
      '.jp-attach-input{display:none;}',
      // attach preview row
      '.jp-attach-row{display:flex;flex-wrap:wrap;gap:8px;padding:2px 2px 0;}',
      '.jp-attach-chip{position:relative;display:flex;align-items:center;gap:6px;',
        'background:#f3f6f9;border:1px solid #dde6ed;border-radius:10px;padding:4px;max-width:220px;}',
      '.jp-attach-chip.jp-att-err{border-color:#f7c2c2;background:#fde8e8;}',
      '.jp-attach-thumb{position:relative;width:48px;height:48px;border-radius:8px;overflow:hidden;',
        'background:#e3eaf0;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
      '.jp-attach-thumb img{width:100%;height:100%;object-fit:cover;display:block;}',
      '.jp-attach-doc{font-size:22px;line-height:1;}',
      '.jp-attach-overlay{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;',
        'background:rgba(0,0,0,0.45);color:#fff;font-size:14px;}',
      '.jp-attach-overlay.jp-overlay-err{background:rgba(229,57,53,0.6);}',
      '.jp-attach-spinner{width:18px;height:18px;border:2px solid rgba(255,255,255,0.4);border-top-color:#fff;',
        'border-radius:50%;animation:jp-spin .8s linear infinite;}',
      '@keyframes jp-spin{to{transform:rotate(360deg);}}',
      '.jp-attach-name{font-size:12px;color:#1a3140;max-width:120px;overflow:hidden;text-overflow:ellipsis;',
        'white-space:nowrap;padding-right:12px;}',
      '.jp-attach-x{position:absolute;top:-7px;right:-7px;width:20px;height:20px;border-radius:50%;',
        'background:#fff;color:#5e7585;border:1px solid #dde6ed;cursor:pointer;font-size:14px;line-height:1;',
        'padding:0;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 4px rgba(0,0,0,0.12);}',
      '.jp-attach-x:hover{background:#1a3140;color:#fff;border-color:#1a3140;}',
      // attachments inside message bubbles
      '.jp-msg-image-wrap{display:block;line-height:0;}',
      '.jp-from-customer .jp-msg-image-wrap{align-self:flex-end;}',
      '.jp-from-bot .jp-msg-image-wrap,.jp-from-agent .jp-msg-image-wrap{align-self:flex-start;}',
      '.jp-msg-image{display:block;max-width:200px;max-height:200px;border-radius:14px;cursor:zoom-in;',
        'background:rgba(0,0,0,0.04);object-fit:cover;box-shadow:0 1px 3px rgba(0,40,80,0.10);}',
      '.jp-msg-image:hover{filter:brightness(1.04);}',
      '.jp-msg-file{display:inline-flex;align-items:center;gap:6px;padding:10px 13px;border-radius:16px;',
        'font-size:14px;text-decoration:none;background:#fff;border:1px solid #e3eaf0;color:#1a3140;',
        'max-width:100%;word-break:break-all;line-height:1.3;}',
      '.jp-from-customer .jp-msg-file{background:linear-gradient(135deg,' + PRIMARY + ' 0%,#0a78b3 100%);',
        'color:#fff;border:none;border-bottom-right-radius:6px;align-self:flex-end;',
        'box-shadow:0 2px 8px rgba(0,136,204,0.22);}',
      '.jp-from-bot .jp-msg-file,.jp-from-agent .jp-msg-file{border-bottom-left-radius:6px;align-self:flex-start;}',
      // lightbox
      '.jp-lightbox{position:fixed;inset:0;background:rgba(0,0,0,0.88);z-index:2147483700;',
        'display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out;',
        'animation:jp-fade-in .15s ease-out;}',
      '.jp-lightbox img{max-width:100%;max-height:100%;border-radius:8px;',
        'box-shadow:0 12px 40px rgba(0,0,0,0.6);}',
      '@keyframes jp-fade-in{from{opacity:0;}to{opacity:1;}}',
      // identify screen
      '.jp-identify{padding:22px 20px;display:flex;flex-direction:column;gap:14px;background:#fff;flex:1;overflow-y:auto;}',
      '.jp-identify .jp-greet{display:flex;align-items:center;gap:12px;margin-bottom:4px;}',
      '.jp-identify .jp-greet-mascot{width:56px;height:56px;flex-shrink:0;background:radial-gradient(circle at 30% 25%,#f0fbe9 0%,#dff5cc 100%);',
        'border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px rgba(95,168,58,0.18);}',
      '.jp-identify .jp-greet-mascot svg{width:46px;height:46px;}',
      '.jp-identify .jp-greet-text{flex:1;}',
      '.jp-identify .jp-greet-h{font-size:17px;font-weight:700;color:#0a3147;line-height:1.25;}',
      '.jp-identify .jp-greet-sub{font-size:13px;color:#5e7585;line-height:1.4;margin-top:3px;}',
      '.jp-identify label{font-size:11px;font-weight:700;color:#5e7585;display:block;margin-bottom:5px;text-transform:uppercase;letter-spacing:0.6px;}',
      '.jp-identify .jp-req{color:#e53935;font-weight:700;margin-left:3px;}',
      '.jp-identify .jp-hint{font-size:12px;color:#5e7585;font-style:italic;margin:-4px 0 -2px 0;line-height:1.3;}',
      '.jp-identify textarea{width:100%;border:1.5px solid #dde6ed;border-radius:10px;padding:10px 13px;font-size:14px;',
        'font-family:inherit;outline:none;resize:vertical;min-height:80px;line-height:1.4;',
        'transition:border-color .15s,box-shadow .15s;background:#f7fafd;}',
      '.jp-identify textarea:focus{border-color:' + PRIMARY + ';background:#fff;box-shadow:0 0 0 3px rgba(0,136,204,0.12);}',
      '.jp-offline-banner{background:linear-gradient(135deg,#fff8e1 0%,#fff3c4 100%);border:1px solid #ffe082;',
        'border-radius:12px;padding:10px 14px;font-size:13px;color:#7a5a00;display:flex;gap:8px;align-items:center;',
        'line-height:1.4;}',
      '.jp-offline-banner .jp-offline-icon{font-size:18px;flex-shrink:0;}',
      '.jp-offline-thanks{text-align:center;padding:32px 24px;}',
      '.jp-offline-thanks .jp-thanks-mascot{width:88px;height:88px;margin:0 auto 16px;',
        'background:radial-gradient(circle at 30% 25%,#f0fbe9 0%,#dff5cc 100%);border-radius:50%;',
        'display:flex;align-items:center;justify-content:center;box-shadow:0 6px 18px rgba(95,168,58,0.22);}',
      '.jp-offline-thanks .jp-thanks-mascot svg{width:72px;height:72px;}',
      '.jp-offline-thanks .jp-thanks-h{font-size:18px;font-weight:700;color:#0a3147;margin-bottom:8px;}',
      '.jp-offline-thanks .jp-thanks-sub{font-size:14px;color:#5e7585;line-height:1.5;margin-bottom:18px;}',
      '.jp-offline-thanks .jp-thanks-again{background:#fff;border:1.5px solid ' + PRIMARY + ';color:' + PRIMARY + ';',
        'padding:9px 16px;border-radius:10px;font-size:13px;font-weight:600;cursor:pointer;}',
      '.jp-offline-thanks .jp-thanks-again:hover{background:' + PRIMARY + ';color:#fff;}',
      '.jp-identify input{width:100%;border:1.5px solid #dde6ed;border-radius:10px;padding:10px 13px;font-size:14px;font-family:inherit;outline:none;',
        'transition:border-color .15s,box-shadow .15s;background:#f7fafd;}',
      '.jp-identify input:focus{border-color:' + PRIMARY + ';background:#fff;box-shadow:0 0 0 3px rgba(0,136,204,0.12);}',
      '.jp-identify .jp-or{display:flex;align-items:center;gap:10px;font-size:11px;color:#9aabb8;text-transform:uppercase;letter-spacing:1.2px;font-weight:600;}',
      '.jp-identify .jp-or::before,.jp-identify .jp-or::after{content:"";flex:1;height:1px;background:#e3eaf0;}',
      '.jp-start-btn{background:linear-gradient(135deg,' + PRIMARY + ' 0%,' + ACCENT + ' 100%);color:#fff;border:none;',
        'padding:12px 16px;border-radius:12px;font-size:14px;font-weight:700;cursor:pointer;margin-top:8px;',
        'box-shadow:0 4px 14px rgba(0,136,204,0.28);transition:transform .15s,box-shadow .15s;letter-spacing:0.2px;}',
      '.jp-start-btn:hover:not(:disabled){transform:translateY(-1px);box-shadow:0 6px 18px rgba(0,136,204,0.36);}',
      '.jp-start-btn:active:not(:disabled){transform:translateY(0);}',
      '.jp-start-btn:disabled{opacity:.55;cursor:not-allowed;box-shadow:none;}',
      '.jp-err{background:#fde8e8;color:#8a1f1f;padding:9px 13px;border-radius:10px;font-size:13px;border:1px solid #f7c2c2;}',
      '.jp-closed-cta{background:linear-gradient(135deg,' + PRIMARY + ',' + ACCENT + ');color:#fff;border:none;padding:10px 16px;border-radius:10px;font-size:13px;font-weight:600;',
        'cursor:pointer;margin-top:8px;width:fit-content;align-self:center;box-shadow:0 4px 10px rgba(0,136,204,0.22);}',
      '.jp-closed-cta:hover{transform:translateY(-1px);}',
      // feedback prompt (on close)
      '.jp-feedback{background:linear-gradient(135deg,#fff8e1 0%,#fff3c4 100%);border:1px solid #ffe082;border-radius:14px;padding:12px 14px;margin-bottom:6px;',
        'animation:jp-msg-in .3s cubic-bezier(.16,1,.3,1) both;}',
      '.jp-feedback-q{font-size:13px;font-weight:700;color:#7a5a00;margin-bottom:9px;text-align:center;letter-spacing:0.1px;}',
      '.jp-feedback-buttons{display:flex;gap:8px;}',
      '.jp-feedback-btn{flex:1;padding:10px 12px;border:1.5px solid #e0d3a0;background:#fff;border-radius:10px;font-size:13px;font-weight:600;',
        'cursor:pointer;color:#5e4a00;transition:all .15s ease;display:flex;align-items:center;justify-content:center;gap:6px;}',
      '.jp-feedback-btn:hover:not(:disabled){transform:translateY(-1px);box-shadow:0 4px 10px rgba(0,0,0,0.08);}',
      '.jp-feedback-btn.jp-fb-yes:hover:not(:disabled){border-color:' + ACCENT + ';color:#067a4a;background:#f0faf4;}',
      '.jp-feedback-btn.jp-fb-no:hover:not(:disabled){border-color:#e68a00;color:#7a4a00;background:#fff5e0;}',
      '.jp-feedback-btn:disabled{opacity:0.5;cursor:wait;}',
      '.jp-feedback-thanks{font-size:13px;text-align:center;color:#067a4a;font-weight:600;padding:6px 4px;display:flex;align-items:center;justify-content:center;gap:6px;}',
      // mobile
      '@media (max-width: 520px){',
        '#jp-chat-panel{right:0;left:0;bottom:0;width:100%;height:82vh;max-height:82vh;border-radius:20px 20px 0 0;}',
        '#jp-chat-bubble{right:16px;bottom:16px;width:62px;height:62px;}',
        '#jp-chat-bubble svg{width:48px;height:48px;}',
        '#jp-chat-callout{right:88px;bottom:24px;max-width:200px;font-size:13px;padding:10px 14px 10px 12px;}',
      '}',
      // reduced motion
      '@media (prefers-reduced-motion: reduce){',
        '#jp-chat-bubble::before,#jp-chat-bubble::after,.jp-wave-hand,#jp-chat-bubble .jp-pickle{animation:none!important;}',
        '.jp-msg-row,#jp-chat-panel.jp-open{animation:none!important;}',
      '}'
    ].join('');

    var styleEl = document.createElement('style');
    styleEl.id = 'jp-chat-styles';
    styleEl.appendChild(document.createTextNode(css));
    document.head.appendChild(styleEl);
  }

  // ---------- Render ----------
  function buildUI() {
    el.root = $('div', { id: 'jp-chat-root' });

    // Bubble
    el.bubble = $('button', {
      id: 'jp-chat-bubble',
      type: 'button',
      'aria-label': 'Open chat with Jersey Pickles support',
      onclick: togglePanel,
      html:
        '<span class="jp-pickle">' + PICKLE_SVG + '</span>' +
        '<span class="jp-close-x">' + CLOSE_SVG + '</span>' +
        '<span class="jp-badge" aria-live="polite">0</span>'
    });

    // Callout "Need help?"
    el.callout = $('div', {
      id: 'jp-chat-callout',
      role: 'button',
      'aria-label': 'Need help? Open chat',
      onclick: function (e) {
        if (e.target.classList && e.target.classList.contains('jp-callout-x')) return;
        hideCallout(true);
        openPanel();
      },
      html:
        '<span class="jp-callout-emoji">👋</span>' +
        '<span class="jp-callout-text">' +
          '<span class="jp-callout-strong">Need help?</span>' +
          '<span class="jp-callout-sub">Chat with us — we reply fast!</span>' +
        '</span>' +
        '<button class="jp-callout-x" aria-label="Dismiss" type="button">×</button>'
    });
    el.callout.querySelector('.jp-callout-x').addEventListener('click', function (e) {
      e.stopPropagation();
      hideCallout(true);
    });

    // Panel
    el.panel = $('div', { id: 'jp-chat-panel', role: 'dialog', 'aria-label': 'Jersey Pickles Support' });

    el.subtitle = $('div', { class: 'jp-subtitle' }, 'We typically reply in a few minutes');
    var avatar = $('div', { class: 'jp-avatar', html: PICKLE_MINI_SVG });
    el.header = $('div', { class: 'jp-header' }, [
      avatar,
      $('div', { class: 'jp-titles' }, [
        $('div', { class: 'jp-title' }, 'Jersey Pickles Support'),
        el.subtitle
      ]),
      $('button', { class: 'jp-close', 'aria-label': 'Close chat', type: 'button', onclick: closePanel, html: CLOSE_SVG,
        style: { background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', padding: '6px 8px', borderRadius: '8px', display: 'flex', alignItems: 'center', position: 'relative', zIndex: '1' } })
    ]);

    el.banner = $('div', { class: 'jp-banner', style: { display: 'none' } });

    el.identify = buildIdentifyScreen();

    el.body = $('div', { class: 'jp-body' });
    el.input = $('textarea', {
      class: 'jp-input', rows: '1', placeholder: 'Tell us what you need in a few words…',
      onkeydown: onInputKeyDown, oninput: onInputChange
    });
    el.send = $('button', {
      class: 'jp-send', type: 'button', 'aria-label': 'Send', onclick: sendFreeText, html: SEND_SVG
    });
    el.attachInput = $('input', {
      type: 'file', class: 'jp-attach-input',
      accept: 'image/*,application/pdf', capture: 'environment',
      onchange: onAttachInputChange
    });
    el.attachBtn = $('button', {
      class: 'jp-attach', type: 'button', 'aria-label': 'Attach photo or PDF',
      onclick: function () { el.attachInput.click(); }, html: ATTACH_SVG
    });
    el.attachPreview = $('div', { class: 'jp-attach-row', style: { display: 'none' } });
    el.footer = $('div', { class: 'jp-footer' }, [
      el.attachPreview,
      $('div', { class: 'jp-input-row' }, [el.attachBtn, el.input, el.send]),
      el.attachInput
    ]);

    el.thread = $('div', {
      class: 'jp-thread',
      style: { display: 'none', flex: '1', flexDirection: 'column', minHeight: '0' }
    }, [el.body, el.footer]);

    el.panel.appendChild(el.header);
    el.panel.appendChild(el.banner);
    el.panel.appendChild(el.identify);
    el.panel.appendChild(el.thread);

    el.root.appendChild(el.bubble);
    el.root.appendChild(el.callout);
    el.root.appendChild(el.panel);
    document.body.appendChild(el.root);

    el.badge = el.bubble.querySelector('.jp-badge');
  }

  function buildIdentifyScreen() {
    var orderInput = $('input', { type: 'text', placeholder: 'e.g. 1234', autocomplete: 'off' });
    var emailInput = $('input', { type: 'email', placeholder: 'you@example.com', autocomplete: 'email' });
    var phoneInput = $('input', { type: 'tel', placeholder: '+1 (555) 123-4567', autocomplete: 'tel' });
    var err = $('div', { class: 'jp-err', style: { display: 'none' } });
    var startBtn = $('button', { class: 'jp-start-btn', type: 'button', onclick: startConversation }, 'Start chat');

    var greet = $('div', { class: 'jp-greet' }, [
      $('div', { class: 'jp-greet-mascot', html: PICKLE_SVG }),
      $('div', { class: 'jp-greet-text' }, [
        $('div', { class: 'jp-greet-h' }, 'Hi there! 👋'),
        $('div', { class: 'jp-greet-sub' }, 'We need your order number plus your email or phone to help you.')
      ])
    ]);

    var orderLabel = $('label', { html: 'Order number<span class="jp-req">*</span>' });
    var emailLabel = $('label', { html: 'Email<span class="jp-req">*</span>' });
    var phoneLabel = $('label', { html: 'Phone<span class="jp-req">*</span>' });

    var screen = $('div', { class: 'jp-identify' }, [
      greet,
      $('div', null, [orderLabel, orderInput]),
      $('div', { class: 'jp-hint' }, 'And one of the following so we can reach you:'),
      $('div', null, [emailLabel, emailInput]),
      $('div', { class: 'jp-or' }, 'or'),
      $('div', null, [phoneLabel, phoneInput]),
      err,
      startBtn
    ]);

    screen._inputs = { order: orderInput, email: emailInput, phone: phoneInput, err: err, btn: startBtn };
    return screen;
  }

  // ---------- Offline (out-of-business-hours) screen ----------
  function buildOfflineScreen() {
    var orderInput = $('input', { type: 'text', placeholder: 'e.g. 1234', autocomplete: 'off' });
    var emailInput = $('input', { type: 'email', placeholder: 'you@example.com', autocomplete: 'email' });
    var phoneInput = $('input', { type: 'tel', placeholder: '+1 (555) 123-4567', autocomplete: 'tel' });
    var messageInput = $('textarea', { rows: '3', placeholder: 'Tell us how we can help…' });
    var err = $('div', { class: 'jp-err', style: { display: 'none' } });
    var sendBtn = $('button', { class: 'jp-start-btn', type: 'button' }, 'Send message');

    var greet = $('div', { class: 'jp-greet' }, [
      $('div', { class: 'jp-greet-mascot', html: PICKLE_SVG }),
      $('div', { class: 'jp-greet-text' }, [
        $('div', { class: 'jp-greet-h' }, "We're offline 💤"),
        $('div', { class: 'jp-greet-sub' }, 'Our team is available ' + BUSINESS_HOURS_LABEL + '. Leave a message and we\'ll reply first thing.')
      ])
    ]);

    var banner = $('div', { class: 'jp-offline-banner' }, [
      $('span', { class: 'jp-offline-icon' }, '🕘'),
      $('span', null, 'Business hours: ' + BUSINESS_HOURS_LABEL)
    ]);

    var screen = $('div', { class: 'jp-identify jp-offline-form' }, [
      greet,
      banner,
      $('div', null, [$('label', { html: 'Order number<span class="jp-req">*</span>' }), orderInput]),
      $('div', { class: 'jp-hint' }, 'And one of the following so we can reach you:'),
      $('div', null, [$('label', { html: 'Email<span class="jp-req">*</span>' }), emailInput]),
      $('div', { class: 'jp-or' }, 'or'),
      $('div', null, [$('label', { html: 'Phone<span class="jp-req">*</span>' }), phoneInput]),
      $('div', null, [$('label', { html: 'Your message<span class="jp-req">*</span>' }), messageInput]),
      err,
      sendBtn
    ]);

    sendBtn.addEventListener('click', function () {
      submitOfflineMessage({
        order: orderInput.value.trim(),
        email: emailInput.value.trim(),
        phone: phoneInput.value.trim(),
        message: messageInput.value.trim(),
        err: err,
        btn: sendBtn,
        orderInput: orderInput, emailInput: emailInput, messageInput: messageInput
      });
    });

    return screen;
  }

  function submitOfflineMessage(f) {
    f.err.style.display = 'none';
    if (!f.order)   { f.err.textContent = 'Please enter your order number.';                  f.err.style.display = 'block'; f.orderInput.focus();   return; }
    if (!f.email && !f.phone) { f.err.textContent = 'Please add your email or phone so we can reach you.'; f.err.style.display = 'block'; f.emailInput.focus(); return; }
    if (!f.message) { f.err.textContent = 'Please write your message.';                        f.err.style.display = 'block'; f.messageInput.focus(); return; }

    f.btn.disabled = true;
    var originalLabel = f.btn.textContent;
    f.btn.textContent = 'Sending…';

    var identifier = { orderNumber: f.order };
    if (f.email) identifier.email = f.email;
    if (f.phone) identifier.phone = f.phone;

    apiPost('/start', { sessionId: state.sessionId || undefined, identifier: identifier })
      .then(function (res) {
        state.sessionId = res.sessionId;
        safeStorageSet(STORAGE_KEY, res.sessionId);
        state.conversationId = res.conversationId || null;
        return apiPost('/message', { sessionId: state.sessionId, content: f.message });
      })
      .then(function () {
        renderOfflineThankYou();
      })
      .catch(function (err) {
        f.err.textContent = err.message || 'Could not send. Please try again.';
        f.err.style.display = 'block';
        f.btn.disabled = false;
        f.btn.textContent = originalLabel;
      });
  }

  function renderOfflineThankYou() {
    if (el.offlineForm) { el.offlineForm.remove(); el.offlineForm = null; }
    var thanks = $('div', { class: 'jp-identify jp-offline-thanks' });
    thanks.appendChild($('div', { class: 'jp-thanks-mascot', html: PICKLE_SVG }));
    thanks.appendChild($('div', { class: 'jp-thanks-h' }, 'Thanks for reaching out! 🙏'));
    thanks.appendChild($('div', { class: 'jp-thanks-sub' },
      "We got your message. Our team will reply during business hours (" + BUSINESS_HOURS_LABEL + ")."));
    var again = $('button', { class: 'jp-thanks-again', type: 'button' }, 'Send another message');
    again.addEventListener('click', function () {
      if (el.offlineThanks) { el.offlineThanks.remove(); el.offlineThanks = null; }
      showOfflineScreen();
    });
    thanks.appendChild(again);
    el.offlineThanks = thanks;
    el.panel.insertBefore(thanks, el.thread);
  }

  function showOfflineScreen() {
    // Hide every other screen + banner
    el.identify.style.display = 'none';
    el.thread.style.display = 'none';
    el.banner.style.display = 'none';
    if (el.offlineThanks) { el.offlineThanks.remove(); el.offlineThanks = null; }
    if (!el.offlineForm) {
      el.offlineForm = buildOfflineScreen();
      el.panel.insertBefore(el.offlineForm, el.thread);
    }
    el.offlineForm.style.display = 'flex';
    el.subtitle.textContent = "Offline — we'll reply " + BUSINESS_HOURS_LABEL;
  }

  function hideOfflineScreen() {
    if (el.offlineForm) el.offlineForm.style.display = 'none';
    if (el.offlineThanks) { el.offlineThanks.remove(); el.offlineThanks = null; }
  }

  // ---------- Callout ----------
  function maybeShowCallout() {
    if (state.calloutShown || state.open) return;
    if (state.sessionId) return; // returning user — they know we're here
    if (safeStorageGet(CALLOUT_DISMISS_KEY)) return;
    state.calloutShown = true;
    el.callout.classList.remove('jp-hiding');
    el.callout.classList.add('jp-show');
    // Auto-hide after 9s if untouched
    setTimeout(function () {
      if (el.callout.classList.contains('jp-show')) hideCallout(false);
    }, 9000);
  }

  function hideCallout(persist) {
    if (!el.callout.classList.contains('jp-show')) return;
    el.callout.classList.add('jp-hiding');
    setTimeout(function () {
      el.callout.classList.remove('jp-show');
      el.callout.classList.remove('jp-hiding');
    }, 260);
    if (persist) safeStorageSet(CALLOUT_DISMISS_KEY, '1');
  }

  // ---------- View control ----------
  function showScreen(name) {
    state.screen = name;
    if (name === 'identify') {
      el.identify.style.display = 'flex';
      el.thread.style.display = 'none';
    } else {
      el.identify.style.display = 'none';
      el.thread.style.display = 'flex';
    }
  }

  function updateSubtitle() {
    var s = state.status;
    var text = 'We typically reply in a few minutes';
    if (s === 'waiting_agent') {
      text = 'Connecting you with an agent…';
    } else if (s === 'with_agent') {
      text = state.assignedAgent
        ? "You're now chatting with " + state.assignedAgent
        : "You're now chatting with our support team";
    } else if (s === 'closed') {
      text = 'This conversation is closed';
    }
    el.subtitle.textContent = text;
  }

  function updateBanner() {
    var s = state.status;
    el.banner.className = 'jp-banner';
    if (s === 'waiting_agent') {
      el.banner.textContent = '⏳ Connecting you with a human agent — they will reply here shortly.';
      el.banner.classList.add('jp-banner-info');
      el.banner.style.display = 'block';
    } else if (s === 'with_agent') {
      el.banner.textContent = '✅ You are now chatting with our team.';
      el.banner.classList.add('jp-banner-success');
      el.banner.style.display = 'block';
    } else if (s === 'closed') {
      el.banner.textContent = 'This conversation was closed.';
      el.banner.style.display = 'block';
    } else {
      el.banner.style.display = 'none';
    }
  }

  function updateFooter() {
    var isClosed = state.status === 'closed';
    var hasUploading = state.pendingAttachments.some(function (a) { return a.status === 'uploading'; });
    var hasDoneAtt = state.pendingAttachments.some(function (a) { return a.status === 'done'; });
    var hasText = !!el.input.value.trim();

    el.input.disabled = isClosed || state.sending;
    el.send.disabled = isClosed || state.sending || hasUploading || (!hasText && !hasDoneAtt);
    if (el.attachBtn) el.attachBtn.disabled = isClosed || state.sending;

    if (isClosed) {
      if (!state.feedbackSubmitted && !el.feedbackBox) {
        el.feedbackBox = buildFeedbackBox();
        el.footer.appendChild(el.feedbackBox);
      }
      if (!el.closedCta) {
        el.closedCta = $('button', { class: 'jp-closed-cta', type: 'button', onclick: resetSession }, 'Start a new conversation');
        el.footer.appendChild(el.closedCta);
      }
      el.input.placeholder = 'Conversation closed';
    } else {
      if (el.feedbackBox) { el.feedbackBox.remove(); el.feedbackBox = null; }
      if (el.closedCta) { el.closedCta.remove(); el.closedCta = null; }
      el.input.placeholder = 'Tell us what you need in a few words…';
    }
  }

  function buildFeedbackBox() {
    var box = $('div', { class: 'jp-feedback' });
    var question = $('div', { class: 'jp-feedback-q' }, 'Was your issue resolved?');
    var yesBtn = $('button', { class: 'jp-feedback-btn jp-fb-yes', type: 'button', html: '👍&nbsp;&nbsp;Yes, resolved' });
    var noBtn  = $('button', { class: 'jp-feedback-btn jp-fb-no',  type: 'button', html: '👎&nbsp;&nbsp;Still need help' });
    var buttons = $('div', { class: 'jp-feedback-buttons' }, [yesBtn, noBtn]);
    box.appendChild(question);
    box.appendChild(buttons);

    yesBtn.addEventListener('click', function () { submitFeedback('positive', box, [yesBtn, noBtn]); });
    noBtn.addEventListener('click',  function () { submitFeedback('negative', box, [yesBtn, noBtn]); });

    return box;
  }

  function submitFeedback(rating, box, buttons) {
    if (state.feedbackSubmitted) return;
    buttons.forEach(function (b) { b.disabled = true; });

    // Best-effort POST to /feedback. If endpoint doesn't exist on backend yet,
    // we silently keep going — the UI thank-you appears anyway.
    fetch(API_PREFIX + '/feedback', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: state.sessionId, rating: rating })
    }).catch(function () { /* swallow */ })
    .then(function () {
      state.feedbackSubmitted = true;
      box.innerHTML = '';
      box.appendChild($('div', { class: 'jp-feedback-thanks' },
        rating === 'positive' ? '🙏  Thanks for your feedback!' : '🙏  Thanks — we’ll keep improving.'));
    });
  }

  function renderAllMessages() {
    el.body.innerHTML = '';
    state.messages.forEach(appendMessageNode);
    if (state.typingShown) el.body.appendChild(buildTypingIndicator(state.typingCaption));
    scrollBodyToBottom();
  }

  function buildTypingIndicator(caption) {
    return $('div', { class: 'jp-msg-row jp-from-bot', id: 'jp-typing-row' }, [
      $('div', { class: 'jp-msg' }, [
        $('div', { class: 'jp-caption' }, caption || 'Pickles Bot'),
        $('div', { class: 'jp-typing' }, [$('span'), $('span'), $('span')])
      ])
    ]);
  }

  function showTypingIndicator(caption, autoHideMs) {
    state.typingCaption = caption || 'Pickles Bot';
    var existing = document.getElementById('jp-typing-row');
    if (existing) {
      var cap = existing.querySelector('.jp-caption');
      if (cap) cap.textContent = state.typingCaption;
    } else {
      state.typingShown = true;
      el.body.appendChild(buildTypingIndicator(state.typingCaption));
      scrollBodyToBottom();
    }
    clearTimeout(state.typingAutoHideTimer);
    if (autoHideMs) state.typingAutoHideTimer = setTimeout(hideTypingIndicator, autoHideMs);
  }

  function hideTypingIndicator() {
    state.typingShown = false;
    state.typingCaption = null;
    clearTimeout(state.typingAutoHideTimer);
    state.typingAutoHideTimer = null;
    var t = document.getElementById('jp-typing-row');
    if (t) t.remove();
  }

  function appendMessageNode(msg) {
    var role = msg.role || 'system';
    var row = $('div', { class: 'jp-msg-row jp-from-' + role });
    var msgWrap = $('div', { class: 'jp-msg' });

    if (role === 'bot' || role === 'agent') {
      var label = role === 'bot' ? 'Pickles Bot' : (state.assignedAgent || 'Support');
      msgWrap.appendChild($('div', { class: 'jp-caption' }, label));
    }

    var hasText = !!(msg.content && String(msg.content).trim());
    var atts = (msg.attachments && msg.attachments.length) ? msg.attachments : null;

    if (hasText) {
      var bubble = $('div', { class: 'jp-bubble' });
      bubble.innerHTML = linkify(escapeHtml(msg.content || ''));
      msgWrap.appendChild(bubble);
    }
    if (atts) {
      atts.forEach(function (a) {
        var node = buildAttachmentNode(a);
        if (node) msgWrap.appendChild(node);
      });
    }
    if (!hasText && !atts) {
      // Render an empty bubble for backwards compatibility (e.g. system msgs).
      msgWrap.appendChild($('div', { class: 'jp-bubble' }));
    }

    if (msg.timestamp && role !== 'system') {
      msgWrap.appendChild($('div', { class: 'jp-time' }, formatTime(msg.timestamp)));
    }
    row.appendChild(msgWrap);
    // If the typing indicator is currently shown, insert above it so new
    // messages don't appear below the "•••" bubble.
    var typingRow = document.getElementById('jp-typing-row');
    if (typingRow) el.body.insertBefore(row, typingRow);
    else el.body.appendChild(row);
  }

  function buildAttachmentNode(att) {
    if (!att || !att.url) return null;
    var name = att.name || 'file';
    if (isImageMime(att.mime, att.url)) {
      var wrap = $('div', { class: 'jp-msg-image-wrap' });
      var img = $('img', {
        class: 'jp-msg-image', src: att.url, alt: name, loading: 'lazy',
        onclick: function () { openLightbox(att.url); }
      });
      wrap.appendChild(img);
      return wrap;
    }
    return $('a', {
      class: 'jp-msg-file', href: att.url, target: '_blank', rel: 'noopener noreferrer'
    }, [
      $('span', null, '📎'),
      $('span', null, name)
    ]);
  }

  function linkify(html) {
    return html.replace(/(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer" style="color:inherit;text-decoration:underline;">$1</a>');
  }

  function scrollBodyToBottom() {
    requestAnimationFrame(function () { el.body.scrollTop = el.body.scrollHeight; });
  }

  function updateUnread() {
    if (state.unread > 0) {
      el.bubble.classList.add('jp-has-unread');
      el.badge.textContent = state.unread > 9 ? '9+' : String(state.unread);
    } else {
      el.bubble.classList.remove('jp-has-unread');
    }
  }

  // ---------- Message store ----------
  function addMessages(messages) {
    if (!messages || !messages.length) return 0;
    var added = 0;
    for (var i = 0; i < messages.length; i++) {
      var m = messages[i];
      if (!m) continue;

      // Customer messages start as a "local-..." optimistic the client created
      // before knowing the server's _id. When the canonical server version
      // arrives, swap the local entry in place so dedup by _id holds afterwards.
      if (m.role === 'customer' && reconcileOptimistic(m)) continue;

      var id = m._id || (m.role + '|' + m.timestamp + '|' + m.content);
      if (state.messageIds[id]) continue;
      state.messageIds[id] = true;
      state.messages.push(m);
      added++;
    }
    if (added) {
      state.messages.sort(function (a, b) {
        return new Date(a.timestamp || 0) - new Date(b.timestamp || 0);
      });
    }
    return added;
  }

  function reconcileOptimistic(serverMsg) {
    // Bridge the local optimistic (local-<rand>) with the canonical server
    // version that arrives via HTTP /message or socket message:new. Backend
    // now guarantees a real _id on every message, so once reconciled, future
    // socket echoes dedupe cleanly by _id.
    var serverAttKey = attachmentsKey(serverMsg.attachments);
    for (var j = state.messages.length - 1; j >= 0; j--) {
      var local = state.messages[j];
      if (local.role !== 'customer') continue;
      if (String(local._id).indexOf('local-') !== 0) continue;
      if ((local.content || '') !== (serverMsg.content || '')) continue;
      // When attachments are involved, also require the urls to match so two
      // image-only optimistics sent back-to-back don't collapse incorrectly.
      if (attachmentsKey(local.attachments) !== serverAttKey) continue;
      delete state.messageIds[local._id];
      var newId = serverMsg._id || (serverMsg.role + '|' + serverMsg.timestamp + '|' + serverMsg.content);
      if (state.messageIds[newId]) return true;
      state.messages[j] = {
        _id: newId,
        role: serverMsg.role,
        type: serverMsg.type || local.type,
        content: serverMsg.content,
        attachments: serverMsg.attachments || local.attachments,
        timestamp: serverMsg.timestamp || local.timestamp
      };
      state.messageIds[newId] = true;
      return true;
    }
    return false;
  }

  function attachmentsKey(atts) {
    if (!atts || !atts.length) return '';
    return atts.map(function (a) { return a && a.url ? a.url : ''; }).join('|');
  }

  function applyState(status, conversationId, assignedAgent, opts) {
    opts = opts || {};
    var fromSocket = !!opts.fromSocket;
    var prevStatus = state.status;
    var prevAgent = state.assignedAgent;
    var wasInit = state.initialized;

    if (status) state.status = status;
    if (conversationId) state.conversationId = conversationId;
    if (assignedAgent !== undefined) {
      var clean = String(assignedAgent || '');
      state.assignedAgent = clean;
      if (clean) safeStorageSet(ASSIGNED_AGENT_KEY, clean);
      else safeStorageRemove(ASSIGNED_AGENT_KEY);
    }

    // Only inject "X joined" / "Conversation closed" inline messages for
    // realtime socket events (not /start, /history, or /message responses —
    // those are state restoration, not events the customer just witnessed).
    if (fromSocket && wasInit && status) {
      var statusChanged = status !== prevStatus;
      var agentChanged = state.assignedAgent !== prevAgent;
      if (statusChanged && status === 'with_agent' && state.assignedAgent) {
        injectSystemMessage('✋ ' + state.assignedAgent + ' joined the conversation');
      } else if (statusChanged && status === 'closed') {
        injectSystemMessage('Conversation closed');
      } else if (!statusChanged && status === 'with_agent' && agentChanged && state.assignedAgent) {
        // Different agent took over while still in with_agent
        injectSystemMessage('✋ ' + state.assignedAgent + ' joined the conversation');
      }
    }

    // Side effects when entering "closed" from any other state: drop any
    // in-flight attachments the customer was about to send, stop the idle
    // timer, and disconnect the socket — the conversation is terminal.
    if (status === 'closed' && prevStatus !== 'closed') {
      clearPendingAttachments();
      stopIdleTimer();
      state.idleReminderShown = false;
      if (state.socket) {
        try { state.socket.disconnect(); } catch (e) {}
        state.socket = null;
      }
    }

    state.initialized = true;
    updateSubtitle();
    updateBanner();
    updateFooter();
  }

  function injectSystemMessage(text) {
    var msg = {
      _id: 'sys-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
      role: 'system', type: 'system', content: text,
      timestamp: new Date().toISOString()
    };
    addMessages([msg]);
    appendMessageNode(msg);
    scrollBodyToBottom();
  }

  // ---------- Panel ----------
  function openPanel() {
    state.open = true;
    el.panel.classList.add('jp-open');
    el.bubble.classList.add('jp-is-open');
    el.bubble.setAttribute('aria-label', 'Close chat');
    state.unread = 0;
    updateUnread();
    hideCallout(false);

    if (!isBusinessHours()) {
      showOfflineScreen();
      return;
    }
    hideOfflineScreen();

    if (state.sessionId && !state._historyLoaded) {
      loadHistory(false);
    } else if (!state.sessionId) {
      showScreen('identify');
    } else {
      // History was loaded previously — show it immediately, then silently
      // re-fetch so anything the socket may have missed shows up.
      showScreen('thread');
      loadHistory(true);
    }

    if (state.sessionId) ensureSocket();
    bumpActivity();
  }

  function closePanel() {
    state.open = false;
    el.panel.classList.remove('jp-open');
    el.bubble.classList.remove('jp-is-open');
    el.bubble.setAttribute('aria-label', 'Open chat');
    stopIdleTimer();
  }

  function togglePanel() { if (state.open) closePanel(); else openPanel(); }

  // ---------- Lifecycle: auto-reset, idle timer, background poll ----------

  // Silent reset: tear down state without touching the UI. Used when the panel
  // is closed and we discover a long-stale "closed" session at page load.
  function silentResetSession() {
    safeStorageRemove(STORAGE_KEY);
    safeStorageRemove(ASSIGNED_AGENT_KEY);
    state.sessionId = null;
    state.conversationId = null;
    state.status = 'bot';
    state.messages = [];
    state.messageIds = Object.create(null);
    state.assignedAgent = '';
    state.initialized = false;
    state._historyLoaded = false;
    state.feedbackSubmitted = false;
    stopIdleTimer();
    state.idleReminderShown = false;
    if (state.socket) {
      try { state.socket.disconnect(); } catch (e) {}
      state.socket = null;
    }
  }

  // Run once at boot if there's a stored session. If it turns out to be a
  // "closed" conversation older than CLOSED_AUTO_RESET_MS, drop it. Otherwise
  // attach the socket so we get realtime events while the panel is closed.
  function silentInitCheck() {
    if (!state.sessionId) return;
    loadHistory(true).then(function () {
      if (state.status === 'closed') {
        var lastTs = lastMessageTimestamp();
        var ageMs = lastTs ? (Date.now() - lastTs) : Infinity;
        if (ageMs > CLOSED_AUTO_RESET_MS) {
          console.info('[jp-chat] stale closed session (age=' + Math.round(ageMs/60000) + 'm) — auto-reset');
          if (state.open) resetSession();
          else silentResetSession();
        }
        // Closed (recent or just-reset) → no socket needed
        return;
      }
      // Live session — connect the socket so realtime events flow.
      ensureSocket();
    });
  }

  function lastMessageTimestamp() {
    for (var i = state.messages.length - 1; i >= 0; i--) {
      var m = state.messages[i];
      var t = m && m.timestamp ? new Date(m.timestamp).getTime() : 0;
      if (t) return t;
    }
    return 0;
  }

  // Idle timer: while the panel is open and the conversation is live, nudge
  // the customer once if there's no activity for IDLE_REMINDER_MS.
  function bumpActivity() {
    state.idleReminderShown = false;
    stopIdleTimer();
    if (!state.open || !state.sessionId || state.status === 'closed') return;
    state.idleTimerId = setTimeout(maybeShowIdleReminder, IDLE_REMINDER_MS);
  }
  function stopIdleTimer() {
    if (state.idleTimerId) { clearTimeout(state.idleTimerId); state.idleTimerId = null; }
  }
  function maybeShowIdleReminder() {
    state.idleTimerId = null;
    if (!state.open || !state.sessionId || state.status === 'closed') return;
    if (state.idleReminderShown) return;
    state.idleReminderShown = true;
    injectSystemMessage('💤 Still there? Send a message or this chat may close.');
  }

  // Background poll: while the panel is closed but we have a live session,
  // re-sync with /history every BG_POLL_MS so server-side closes don't go
  // unnoticed if the socket died silently.
  function startBackgroundPoll() {
    stopBackgroundPoll();
    state.bgPollIntervalId = setInterval(function () {
      if (state.open) return;
      if (!state.sessionId) return;
      if (state.status === 'closed') return;
      loadHistory(true);
    }, BG_POLL_MS);
  }
  function stopBackgroundPoll() {
    if (state.bgPollIntervalId) { clearInterval(state.bgPollIntervalId); state.bgPollIntervalId = null; }
  }

  // ---------- Init ----------
  function init() {
    injectStyles();
    buildUI();
    state.sessionId = safeStorageGet(STORAGE_KEY);
    state.assignedAgent = safeStorageGet(ASSIGNED_AGENT_KEY) || '';

    // Expose debug handle so support team can poke the socket from DevTools.
    window.jpChat = {
      get socket() { return state.socket; },
      state: state,
      open: openPanel,
      close: closePanel,
      reset: resetSession,
      refresh: function () { if (state.sessionId) return loadHistory(true); },
      isBusinessHours: isBusinessHours,
      forceOffline: function () { showOfflineScreen(); }   // for QA from console
    };

    // Schedule callout after page has settled
    setTimeout(maybeShowCallout, 3500);

    // For an existing session: hydrate state silently. If the convo is live,
    // silentInitCheck also attaches the socket so unread badges work while
    // the panel is closed. If it's a stale "closed" convo (>1h), it auto-resets.
    if (state.sessionId) silentInitCheck();
    startBackgroundPoll();
  }

  // ---------- Identify ----------
  function startConversation() {
    var refs = el.identify._inputs;
    var order = refs.order.value.trim();
    var email = refs.email.value.trim();
    var phone = refs.phone.value.trim();
    refs.err.style.display = 'none';

    if (!order) {
      refs.err.textContent = 'Please enter your order number.';
      refs.err.style.display = 'block';
      refs.order.focus();
      return;
    }
    if (!email && !phone) {
      refs.err.textContent = 'Please add your email or phone so we can reach you.';
      refs.err.style.display = 'block';
      refs.email.focus();
      return;
    }

    var identifier = { orderNumber: order };
    if (email) identifier.email = email;
    if (phone) identifier.phone = phone;

    refs.btn.disabled = true;
    refs.btn.textContent = 'Starting…';

    apiPost('/start', {
      sessionId: state.sessionId || undefined,
      identifier: identifier
    }).then(function (res) {
      state.sessionId = res.sessionId;
      safeStorageSet(STORAGE_KEY, res.sessionId);
      state.conversationId = res.conversationId || null;
      state.status = res.status || 'bot';
      addMessages(res.messages || []);
      state._historyLoaded = true;
      renderAllMessages();
      applyState(state.status, state.conversationId, res.assignedAgent);
      showScreen('thread');
      ensureSocket();
    }).catch(function (err) {
      refs.err.textContent = err.message || 'Could not start chat. Please try again.';
      refs.err.style.display = 'block';
    }).then(function () {
      refs.btn.disabled = false;
      refs.btn.textContent = 'Start chat';
    });
  }

  function resetSession() {
    safeStorageRemove(STORAGE_KEY);
    state.sessionId = null;
    state.conversationId = null;
    state.status = 'bot';
    state.messages = [];
    state.messageIds = Object.create(null);
    state.assignedAgent = '';
    state.initialized = false;
    safeStorageRemove(ASSIGNED_AGENT_KEY);
    state._historyLoaded = false;
    state.feedbackSubmitted = false;
    stopIdleTimer();
    state.idleReminderShown = false;
    if (el.feedbackBox) { el.feedbackBox.remove(); el.feedbackBox = null; }
    if (state.socket) {
      try { state.socket.disconnect(); } catch (e) {}
      state.socket = null;
    }
    el.body.innerHTML = '';
    clearPendingAttachments();
    el.identify._inputs.order.value = '';
    el.identify._inputs.email.value = '';
    el.identify._inputs.phone.value = '';
    el.identify._inputs.err.style.display = 'none';
    showScreen('identify');
    applyState('bot', null);
  }

  function loadHistory(silent) {
    return apiGet('/history/' + encodeURIComponent(state.sessionId)).then(function (res) {
      var convo = res.conversation || res;
      state.conversationId = convo.conversationId || convo._id || state.conversationId;
      var newStatus = convo.status || res.status || 'bot';
      var agentName = (convo.assignedAgent !== undefined ? convo.assignedAgent : res.assignedAgent);
      var msgs = convo.messages || res.messages || [];
      var added = addMessages(msgs);
      state._historyLoaded = true;
      if (!silent || added > 0) renderAllMessages();
      applyState(newStatus, state.conversationId, agentName);
      if (!silent) showScreen('thread');
      return added;
    }).catch(function (err) {
      // On silent refresh, don't wipe the session for transient errors.
      if (!silent) resetSession();
      else console.warn('[jp-chat] silent history refresh failed', err && err.message);
    });
  }

  // ---------- File uploads ----------
  function uploadChatFile(file) {
    var fd = new FormData();
    fd.append('file', file);
    // IMPORTANT: do NOT set Content-Type — browser must build the multipart boundary.
    return fetch(API_BASE + '/api/chat/upload', { method: 'POST', body: fd })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || (j && j.success === false)) {
            var err = new Error((j && j.message) || ('Upload failed (HTTP ' + r.status + ')'));
            err.payload = j;
            throw err;
          }
          return j; // { success, url, mime, name, size }
        });
      });
  }

  function onAttachInputChange(e) {
    var input = e.target;
    var files = input.files;
    if (files && files.length) {
      for (var i = 0; i < files.length; i++) handleFilePicked(files[i]);
    }
    input.value = ''; // allow picking the same file again
  }

  function handleFilePicked(file) {
    if (!file) return;
    if (file.size > MAX_FILE_BYTES) {
      showSoftError('"' + file.name + '" is too large. Max 10 MB.');
      return;
    }
    if (file.type && ALLOWED_MIMES.indexOf(file.type) === -1) {
      showSoftError('"' + file.name + '" is not a supported file type. Use an image or PDF.');
      return;
    }

    var id = 'att-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
    var entry = {
      id: id,
      name: file.name || 'file',
      mime: file.type || '',
      size: file.size,
      status: 'uploading',
      url: null,
      localPreviewUrl: null,
      errorMsg: null
    };
    if (file.type && file.type.indexOf('image/') === 0 && typeof URL !== 'undefined' && URL.createObjectURL) {
      try { entry.localPreviewUrl = URL.createObjectURL(file); } catch (e) {}
    }
    state.pendingAttachments.push(entry);
    renderAttachPreview();
    updateFooter();

    uploadChatFile(file).then(function (res) {
      entry.status = 'done';
      entry.url = res.url;
      entry.mime = res.mime || entry.mime;
      entry.name = res.name || entry.name;
      entry.size = res.size || entry.size;
      renderAttachPreview();
      updateFooter();
    }).catch(function (err) {
      entry.status = 'error';
      entry.errorMsg = err.message || 'Upload failed';
      renderAttachPreview();
      updateFooter();
      showSoftError(entry.errorMsg);
    });
  }

  function removePendingAttachment(id) {
    for (var i = 0; i < state.pendingAttachments.length; i++) {
      if (state.pendingAttachments[i].id === id) {
        var entry = state.pendingAttachments[i];
        if (entry.localPreviewUrl) {
          try { URL.revokeObjectURL(entry.localPreviewUrl); } catch (e) {}
        }
        state.pendingAttachments.splice(i, 1);
        break;
      }
    }
    renderAttachPreview();
    updateFooter();
  }

  function clearPendingAttachments() {
    state.pendingAttachments.forEach(function (a) {
      if (a.localPreviewUrl) { try { URL.revokeObjectURL(a.localPreviewUrl); } catch (e) {} }
    });
    state.pendingAttachments = [];
    renderAttachPreview();
  }

  function renderAttachPreview() {
    if (!el.attachPreview) return;
    el.attachPreview.innerHTML = '';
    if (!state.pendingAttachments.length) {
      el.attachPreview.style.display = 'none';
      return;
    }
    el.attachPreview.style.display = 'flex';
    state.pendingAttachments.forEach(function (att) {
      var isImage = isImageMime(att.mime, att.url || att.name);
      var chip = $('div', { class: 'jp-attach-chip' + (att.status === 'error' ? ' jp-att-err' : '') });
      var thumb = $('div', { class: 'jp-attach-thumb' });
      if (isImage && (att.localPreviewUrl || att.url)) {
        thumb.appendChild($('img', { src: att.localPreviewUrl || att.url, alt: '' }));
      } else {
        thumb.appendChild($('span', { class: 'jp-attach-doc' }, '📄'));
      }
      if (att.status === 'uploading') {
        thumb.appendChild($('div', { class: 'jp-attach-overlay' }, [$('div', { class: 'jp-attach-spinner' })]));
      } else if (att.status === 'error') {
        thumb.appendChild($('div', { class: 'jp-attach-overlay jp-overlay-err' }, '⚠'));
      }
      chip.appendChild(thumb);
      if (!isImage) {
        chip.appendChild($('div', { class: 'jp-attach-name', title: att.name }, att.name));
      }
      chip.appendChild($('button', {
        class: 'jp-attach-x', type: 'button', 'aria-label': 'Remove attachment',
        onclick: function () { removePendingAttachment(att.id); }
      }, '×'));
      el.attachPreview.appendChild(chip);
    });
  }

  function isImageMime(mime, urlOrName) {
    if (mime && mime.indexOf('image/') === 0) return true;
    if (urlOrName && /\.(png|jpe?g|gif|webp|heic|heif)(\?|#|$)/i.test(urlOrName)) return true;
    return false;
  }

  function openLightbox(url) {
    var overlay = $('div', {
      class: 'jp-lightbox', role: 'dialog', 'aria-label': 'Image preview',
      onclick: function () { closeOverlay(); }
    });
    overlay.appendChild($('img', { src: url, alt: '' }));
    document.body.appendChild(overlay);
    function onKey(e) {
      if (e.key === 'Escape') closeOverlay();
    }
    function closeOverlay() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
    }
    document.addEventListener('keydown', onKey);
  }

  // ---------- Sending ----------
  function sendFreeText() {
    if (state.sending || state.status === 'closed') return;
    var text = el.input.value.trim();
    var hasUploading = state.pendingAttachments.some(function (a) { return a.status === 'uploading'; });
    if (hasUploading) return; // updateFooter already disables send while uploading
    var doneAtts = state.pendingAttachments
      .filter(function (a) { return a.status === 'done' && a.url; })
      .map(function (a) { return { url: a.url, mime: a.mime, name: a.name }; });
    if (!text && !doneAtts.length) return;

    state.sending = true;
    el.input.value = '';
    autoResizeInput();
    clearPendingAttachments();
    bumpActivity();

    var optimistic = {
      _id: 'local-' + Date.now() + '-' + Math.random(),
      role: 'customer',
      type: (!text && doneAtts.length) ? 'image' : 'text',
      content: text,
      attachments: doneAtts.length ? doneAtts.slice() : undefined,
      timestamp: new Date().toISOString()
    };
    addMessages([optimistic]);
    appendMessageNode(optimistic);
    // Show "thinking" bubble while the AI/agent composes a reply. Caption is
    // "Pickles Bot" until the conversation is handed off; once with_agent we
    // re-label to "Support" so the customer knows a human is involved.
    showTypingIndicator(state.status === 'with_agent' ? 'Support' : 'Pickles Bot');
    updateFooter();

    var body = { sessionId: state.sessionId };
    if (text) body.content = text;
    if (doneAtts.length) body.attachments = doneAtts;

    apiPost('/message', body)
      .then(function (res) {
        hideTypingIndicator();
        var added = addMessages(res.newMessages || []);
        if (added) renderAllMessages();
        applyState(res.status, state.conversationId, res.assignedAgent);
      })
      .catch(function (err) {
        hideTypingIndicator();
        showSoftError(err.message || 'Could not send. Please try again.');
      })
      .then(function () { state.sending = false; updateFooter(); });
  }

  function showSoftError(msg) {
    var sysMsg = {
      _id: 'err-' + Date.now(),
      role: 'system', type: 'system', content: '⚠ ' + msg,
      timestamp: new Date().toISOString()
    };
    addMessages([sysMsg]);
    appendMessageNode(sysMsg);
    scrollBodyToBottom();
  }

  // ---------- Input handlers ----------
  function onInputKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendFreeText(); }
  }
  function onInputChange() { autoResizeInput(); updateFooter(); emitTyping(); bumpActivity(); }
  function autoResizeInput() {
    el.input.style.height = 'auto';
    el.input.style.height = Math.min(el.input.scrollHeight, 120) + 'px';
  }
  function emitTyping() {
    if (!state.socket || !state.socket.connected) return;
    if (state.typingTimeoutId) return;
    try { state.socket.emit('typing'); } catch (e) {}
    state.typingTimeoutId = setTimeout(function () { state.typingTimeoutId = null; }, 1000);
  }

  // ---------- Socket ----------
  function ensureSocket() {
    if (state.socket || state.socketLoading || !state.sessionId) return;
    state.socketLoading = true;
    console.info('[jp-chat] loading socket.io client…');

    var p = window.io ? Promise.resolve() : loadScript(SOCKET_CDN);
    p.then(function () {
      if (!window.io) throw new Error('socket.io unavailable');
      var s = window.io(SOCKET_URL, {
        path: SOCKET_PATH,
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionDelay: 1500
      });
      state.socket = s;
      console.info('[jp-chat] socket created → namespace', SOCKET_URL, 'path', SOCKET_PATH);

      s.on('connect', function () {
        console.info('[jp-chat] ✅ socket connected. id=', s.id, '→ emitting join with sessionId', state.sessionId);
        try { s.emit('join', { sessionId: state.sessionId }); } catch (e) {}
      });
      s.on('connect_error', function (err) {
        console.warn('[jp-chat] ❌ socket connect_error:', err && err.message, err);
      });
      s.on('joined', function (data) {
        console.info('[jp-chat] ✅ joined room ←', data);
        if (data && data.conversationId) state.conversationId = data.conversationId;
        if (data && data.status) applyState(data.status, state.conversationId);
      });
      s.on('message:new', function (data) {
        console.info('[jp-chat] 📩 message:new ←', data);
        if (!data || !data.message) return;
        var added = addMessages([data.message]);
        if (added) {
          hideTypingIndicator();
          if (state.open) { appendMessageNode(data.message); scrollBodyToBottom(); }
          else if (data.message.role !== 'customer') { state.unread += 1; updateUnread(); }
          bumpActivity();
        }
      });
      s.on('status:changed', function (data) {
        console.info('[jp-chat] status:changed ←', data);
        if (!data) return;
        applyState(data.status, data.conversationId || state.conversationId, data.assignedAgent, { fromSocket: true });
      });
      s.on('typing', function (data) {
        if (data && data.from === 'agent') showTypingIndicator('Support', 4000);
      });
      s.on('error', function (data) {
        console.warn('[jp-chat] socket error event ←', data);
        if (data && data.message) showSoftError(data.message);
      });
      s.on('disconnect', function (reason) {
        console.info('[jp-chat] socket disconnected:', reason);
        hideTypingIndicator();
      });
      // Recover any messages missed during a transient disconnect.
      s.io.on('reconnect', function (n) {
        if (!state.sessionId || state.status === 'closed') {
          console.info('[jp-chat] 🔄 socket reconnected (#' + n + ') — skipping history refresh (no live session)');
          return;
        }
        console.info('[jp-chat] 🔄 socket reconnected after', n, 'attempts → refreshing history');
        loadHistory(true);
      });
    }).catch(function (err) {
      console.warn('[jp-chat] socket.io client failed to load:', err && err.message);
    }).then(function () { state.socketLoading = false; });
  }

  // ---------- Boot ----------
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
